// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"3f5dc6cb4f65c0630a23","655":"03e6e12fd9def9aec2ad"}[chunkId] + ".js";
};